const ITEMS = [
  "Srinagar", "Dal Lake", "Gulmarg", "Pahalgam", "Sonamarg",
  "Doodhpathri", "Yusmarg", "Gurez Valley", "Houseboats", "Shikara Rides", "Wazwan Evenings",
];

const Marquee = () => (
  <div className="overflow-hidden bg-[#0F2F24] py-4" aria-hidden="true" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max items-center gap-8">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center gap-8">
          <span className="font-serif text-lg sm:text-xl italic text-[#FAF7F2]/85 whitespace-nowrap">{item}</span>
          <span className="h-1.5 w-1.5 rotate-45 bg-[#D99B26] shrink-0" />
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
